import {
  playEngineVersions,
  type PlayEngineVersion,
} from "@/pages/play/engineVersion";
import { useI18n } from "@/shared/i18n/LanguageContext";

type EngineVersionSwitchProps = {
  value: PlayEngineVersion;
  onChange: (value: PlayEngineVersion) => void;
};

export function EngineVersionSwitch({ value, onChange }: EngineVersionSwitchProps) {
  const { copy } = useI18n();

  return (
    <section className="play-engine-switch" aria-label={copy.play.engineSwitch.label}>
      <div className="play-engine-switch__label">
        <span>{copy.play.engineSwitch.label}</span>
      </div>
      <div className="play-engine-switch__options" role="tablist">
        {playEngineVersions.map((version) => {
          const active = value === version;
          const option = copy.play.engineSwitch.versions[version];
          return (
            <button
              key={version}
              type="button"
              className={
                active
                  ? "play-engine-switch__option play-engine-switch__option--active"
                  : "play-engine-switch__option"
              }
              aria-selected={active}
              role="tab"
              onClick={() => onChange(version)}
            >
              <strong>{option.label}</strong>
              <span>{option.meta}</span>
            </button>
          );
        })}
      </div>
    </section>
  );
}

